declare global {
    interface Window {
        SBK_ATM_FRONTEND_CONFIG: DynamicConfig;
    }
}

interface DynamicConfig {
    clientId: string,
    clientSecret: string,
    tokenUrl: string,
    atmUrl: string,
}

export default window.SBK_ATM_FRONTEND_CONFIG as DynamicConfig;
